import { HorizontalSafeAreaContainer } from '../../../components';
import { PersonalDataDetailsScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <PersonalDataDetailsScreen />
    </HorizontalSafeAreaContainer>
  );
}
